import type { IconData } from '@stacksjs/iconify-core'

export const codepenCircle: IconData = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M10.402 5.131a.79.79 0 0 0-.887.01L5.54 7.91a.79.79 0 0 0-.339.648v2.982a.79.79 0 0 0 .355.659l4.039 2.67a.79.79 0 0 0 .87 0l4.12-2.722a.79.79 0 0 0 .354-.658v-2.93a.79.79 0 0 0-.354-.66l-4.184-2.768zm3.077 3.23l-1.523 1.023l-1.428-1.038l-.009-2.043zM9.486 6.306v1.999L8.023 9.327l-1.46-.979zM6.164 9.333l.944.633l-.944.661zm3.347 4.261l-2.947-1.976l1.472-1.029l1.475.99zm-.56-3.644l.955-.667l1.11.73l-.984.662zm1.601 3.644v-2.016l1.41-.944l1.517.997zm3.347-2.933l-1-.657l1-.671z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default codepenCircle
